import { useEffect, useRef } from 'react';

import closeIcon from '../../assets/icons/close-icon.svg';
import { ZahtjevTable } from '../../common/types/types';
import { pretvoriDatumuFormatTabliceSimple } from '../../common/utils/HelperFunction';
import { useAppSelector } from '../../store/hooks/hooks';

interface Props {
  setModalArchivedOn: (modalArchivedOn: boolean) => void;
  details: ZahtjevTable | undefined;
}

export const ArchivedDocumentDetails = (props: Props) => {
  const reachedProcesses = useAppSelector((state) => state.processes.reachedProcesses);
  const process = reachedProcesses.find((processItem) => {
    const currentProcID = processItem.Name?.split(' ')[0];
    return currentProcID === props.details?.ProcessID;
  })?.Name;

  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        props.setModalArchivedOn(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        props.setModalArchivedOn(false);
      }
    };
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <div className='modal-active dark-100'>
      <div className='main-modal'>
        <div className='padding-bottom-5' ref={modalRef}>
          <div className='modal-archived bg-gray-700'>
            <div className='modal-archived__header'>
              <h3 className='font-h3-regular margin-bottom-0'>{props.details?.Name}</h3>
              <img className='modal-archived__close' src={closeIcon} alt='' onClick={() => props.setModalArchivedOn(false)} />
            </div>
            <div className='modal-archived__content bg-gray-500'>
              <div className='modal-archived__content__item'>
                <p>Name</p>
                <p>{props.details?.Name}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Supplier Name</p>
                <p>{props.details?.SupplierName}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Group</p>
                <p>{props.details?.InvoiceGroup}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>VAT</p>
                <p>{props.details?.CompanyVAT}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Invoice Number</p>
                <p>{props.details?.InvoiceNumber}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Invoice Date</p>
                <p>{pretvoriDatumuFormatTabliceSimple(props.details?.InvoiceDate, 'Incorrect date format')}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Invoice DueDate</p>
                <p>{pretvoriDatumuFormatTabliceSimple(props.details?.InvoiceDueDate, 'Incorrect date format')}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Neto</p>
                <p>{Number(props.details?.InvoiceSubtotal).toFixed(2)}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Currency</p>
                <p>{props.details?.InvoiceCurrency}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Bruto</p>
                <p>{Number(props.details?.InvoiceTotal).toFixed(2)}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>Process Type</p>
                <p>{process}</p>
              </div>
              <div className='modal-archived__content__item'>
                <p>RAC</p>
                <p>{props.details?.DmsID}</p>
              </div>

              {/* <div>
            <p>{props.details?.Name}</p>
            <p>{props.details?.InvoiceGroup}</p>
            <p>{props.details?.CompanyVAT}</p>
            <p>{props.details?.InvoiceNumber}</p>
            <p>{props.details?.InvoiceDate}</p>
            <p>{props.details?.InvoiceDueDate}</p>
            <p>{props.details?.InvoiceSubtotal}</p>
            <p>{props.details?.InvoiceCurrency}</p>
            <p>{props.details?.InvoiceTotal}</p>
            <p>{props.details?.ProcessID}</p>
          </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
